import { Helmet } from "react-helmet";

const Head = ({ title }: any) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{title}</title>
    </Helmet>
  );
};

export default Head;
